import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiUser, FiBriefcase, FiMail, FiPhone, FiHash, FiMapPin, FiMap } from 'react-icons/fi';
import FormWizard from '../../ui/FormWizard';
import { InputField, SelectField, FormRow } from '../../ui/InputField';

const AlterarCliente = () => {
    const [cep, setCep] = useState('');
    const [cidade, setCidade] = useState('');
    const [bairro, setBairro] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [uf, setUf] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [razao, setRazao] = useState('');
    const [fantasia, setFantasia] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [ieRg, setIeRg] = useState('');
    const [ddd, setDdd] = useState('');
    const [validCpfCnpj, setValidCpfCnpj] = useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const parametro = useParams();
    const [rotaId, setRotaId] = useState('');
    const [rotasServer, setRotasServer] = useState([]);

    useEffect(() => {
        setLoading(true);
        fetch(Apis.urlListarOneClientes, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id })
        }).then(r => r.json()).then(result => {
            if (result.retorno.sucesso) {
                const r0 = result.registros[0];
                setCep(r0.cep); setCidade(r0.cidade); setBairro(r0.bairro);
                setLogradouro(r0.logradouro); setUf(r0.uf); setNumero(r0.numero);
                setComplemento(r0.complemento); setRazao(r0.nome); setFantasia(r0.apelido);
                setEmail(r0.email); setTelefone(r0.fone1); setCpfCnpj(r0.cnpj_cpf);
                setIeRg(r0.ie_rg); setRotaId(r0.rota_id);
                setLoading(false);
            } else {
                navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-clientes`);
            }
        });
    }, []);

    useEffect(() => {
        fetch(Apis.urlListarRotas, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({})
        }).then(r => r.json()).then(result => setRotasServer(result.registros));
    }, []);

    useEffect(() => {
        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(r => r.json())
                .then(result => {
                    setCidade(result.localidade); setBairro(result.bairro);
                    setLogradouro(result.logradouro); setUf(result.uf);
                    setComplemento(result.complemento); setDdd(result.ddd);
                });
        }
        if (cpfCnpj.length >= 11 && cpfCnpj.length <= 18) {
            setValidCpfCnpj(cpf.isValid(cpfCnpj) || cnpj.isValid(cpfCnpj) ? true : false);
        }
    }, [cep, cpfCnpj]);

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const handleSubmit = () => {
        if (validCpfCnpj === false || cpfCnpj.length < 11) { alertaErro("CPF/CNPJ inválido!"); return; }
        if (razao === '' || cpfCnpj === '') { alertaErro('Preencha os campos obrigatórios(*)'); return; }
        if (razao !== '' && cpfCnpj !== '' && validCpfCnpj === true) {
            const data = {
                "rota_id": rotaId, "id": parametro.id,
                "nome": razao, "apelido": fantasia,
                "logradouro": logradouro, "numero": numero, "cep": cep,
                "bairro": bairro, "complemento": complemento, "cidade": cidade,
                "uf": uf, "email": email, "fone1": telefone,
                "cnpj_cpf": cpfCnpj, "ie_rg": ieRg
            };
            fetch(Apis.urlAlterarCliente, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
                body: JSON.stringify(data)
            }).then(r => r.json()).then(result => {
                if (result.retorno.sucesso) {
                    navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-clientes`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
            });
        }
    };

    if (loading) return <Loading />;

    return (
        <FormWizard
            title="Alteração de Cliente"
            icon={<FiUser />}
            steps={['Identificação', 'Endereço & Rota']}
            onSubmit={handleSubmit}
            submitLabel="Salvar Alterações"
        >
            {/* Passo 1 — Identificação */}
            <>
                <InputField label="Razão Social" icon={<FiBriefcase />} required
                    placeholder="Razão Social" onChange={e => setRazao(e.target.value)} value={razao} />
                <InputField label="Nome Fantasia" icon={<FiBriefcase />}
                    placeholder="Nome Fantasia" onChange={e => setFantasia(e.target.value)} value={fantasia} />
                <FormRow>
                    <InputField label="CPF / CNPJ" icon={<FiHash />} required
                        placeholder="CPF ou CNPJ" onChange={e => setCpfCnpj(e.target.value)} value={cpfCnpj} />
                    <InputField label="IE / RG" icon={<FiHash />}
                        placeholder="Inscrição Estadual ou RG" onChange={e => setIeRg(e.target.value)} value={ieRg} />
                </FormRow>
                <FormRow>
                    <InputField label="E-mail" icon={<FiMail />}
                        placeholder="E-mail" onChange={e => setEmail(e.target.value)} value={email} />
                    <InputField label="Telefone" icon={<FiPhone />}
                        placeholder="Telefone" value={telefone}
                        onChange={e => {
                            if (telefone === '' && ddd !== '') setTelefone(`(${ddd}) ` + e.target.value);
                            else setTelefone(e.target.value);
                        }} />
                </FormRow>
            </>

            {/* Passo 2 — Endereço & Rota */}
            <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: 12 }}>
                    <InputField label="CEP" icon={<FiMapPin />}
                        placeholder="CEP (8 dígitos)" onChange={e => setCep(e.target.value)} value={cep} />
                    <InputField label="UF" placeholder="UF" onChange={e => setUf(e.target.value)} value={uf} />
                </div>
                <InputField label="Logradouro" icon={<FiMapPin />}
                    placeholder="Logradouro" onChange={e => setLogradouro(e.target.value)} value={logradouro} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <InputField label="Número" placeholder="Número" onChange={e => setNumero(e.target.value)} value={numero} />
                    <InputField label="Bairro" placeholder="Bairro" onChange={e => setBairro(e.target.value)} value={bairro} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <InputField label="Complemento" placeholder="Complemento" onChange={e => setComplemento(e.target.value)} value={complemento} />
                    <InputField label="Cidade" placeholder="Cidade" onChange={e => setCidade(e.target.value)} value={cidade} />
                </div>
                {rotasServer?.length > 0 && (
                    <SelectField label="Rota" icon={<FiMap />}
                        onChange={e => setRotaId(e.target.value)} value={rotaId}>
                        <option value="">— sem rota —</option>
                        {rotasServer.map(rota => (
                            <option key={rota.id} value={rota.id} style={{ textTransform: 'uppercase' }}>{rota.nome}</option>
                        ))}
                    </SelectField>
                )}
            </>
        </FormWizard>
    );
};

export default AlterarCliente;
